module.exports = __webpack_public_path__ + "06_mustache_grey.7e208c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/06_mustache_grey.png
// module id = hydA
// module chunks = 0